import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Section } from '../components/ui/Section';
import { Reveal } from '../components/ui/Reveal';
import { posts } from '../data/posts';
export function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Journal — Branding, Web & Marketing | Yetu Design Lab';
  }, []);
  const [featured, ...rest] = posts;
  return <Layout data-id="element-283" data-mp="37zf6o1srhc6">
      <Section aria-labelledby="journal-title" data-id="element-284" data-mp="35d9ktygvbwl">
        <Reveal onMount data-id="element-285" data-mp="3uf27jitdftnz">
          <p className="t-label text-accent" data-id="element-286" data-mp="3ufln4svju5yu">Journal</p>
          <h1 id="journal-title" className="t-h1 mt-6 max-w-[16ch] text-balance" data-id="element-287" data-mp="cy15znljbdus">
            Thoughts on <span className="t-serif text-accent" data-id="element-288" data-mp="86aq723tvxvz">design</span> &amp;
            growth.
          </h1>
          <p className="t-lead measure mt-8 text-mut" data-id="element-289" data-mp="3gm2qvdhurteu">
            Practical perspectives on branding, web design, marketing, and how a
            senior studio actually ships work — from the team at Yetu Design
            Lab.
          </p>
        </Reveal>
      </Section>

      {/* Featured article */}
      <Section className="!pt-0" data-id="element-290" data-mp="273nk45m64jhh">
        <Reveal data-id="element-291" data-mp="272vv5dn2tk06">
          <Link to={`/blog/${featured.slug}`} className="panel group block p-8 transition-colors hover:border-line-2 md:p-12" data-id="element-292" data-mp="272ciocg73ntj">
            <p className="t-label text-subtle" data-id="element-293" data-mp="2fvh3s0wzuaba">
              <span className="text-accent" data-id="element-294" data-mp="1j6hucikob2hi">{featured.category}</span> ·{' '}
              {featured.date} · {featured.readTime}
            </p>
            <h2 className="t-h2 mt-6 max-w-[22ch] text-balance transition-colors group-hover:text-accent" data-id="element-295" data-mp="1o6mau8lkzx7q">
              {featured.title}
            </h2>
            <p className="t-body measure mt-5 text-mut" data-id="element-296" data-mp="1x69dsytylb2w">{featured.excerpt}</p>
          </Link>
        </Reveal>
      </Section>

      {/* Article index */}
      <Section className="!pt-0" aria-label="All articles" data-id="element-297" data-mp="33ljvgfwzxe9d">
        <ul className="border-b border-line" data-id="element-298" data-mp="38kwqhny0trn1">
          {rest.map(post => <Reveal as="li" key={post.slug} className="border-t border-line" data-id="element-299" data-mp="18j6n4kvacr2t">
              <Link to={`/blog/${post.slug}`} className="group -mx-4 grid grid-cols-1 gap-3 px-4 py-8 transition-colors hover:bg-surface md:grid-cols-12 md:items-baseline md:gap-8" data-id="element-300" data-mp="18l9n9xq5k0l9">
                <p className="t-label text-subtle md:col-span-3" data-id="element-301" data-mp="1dij8f16idq3a">
                  <span className="text-accent" data-id="element-302" data-mp="1dg6t6vs4xttx">{post.category}</span> ·{' '}
                  {post.readTime}
                </p>
                <h2 className="t-h3 transition-colors group-hover:text-accent md:col-span-6" data-id="element-303" data-mp="ktvszm8fxuxn">
                  {post.title}
                </h2>
                <p className="t-small text-mut md:col-span-3 md:text-right" data-id="element-304" data-mp="zja1ks4708bz">
                  {post.date}
                </p>
              </Link>
            </Reveal>)}
        </ul>
      </Section>
    </Layout>;
}